import { SearchStatus } from '../components/SearchResultPage';
import { ContentTypeFilterValue, ContentTypeFilterAllOption } from '../models/ContentTypeFilterValue';
import { DisplaySelection } from '../models/DisplaySelection';
import { MixedContentTypeSearchResult } from '../models/SearchResultTypes';
import { SortSelection } from '../models/SortSelection';

export interface SearchState {
  status: SearchStatus;
  searchTerm: string;
  totalCount: number;
  selectedContentTypeFilterValue: ContentTypeFilterValue;
  mixedContentType: { searchResult?: MixedContentTypeSearchResult };
  sortBy?: SortSelection;
  displayBy?: DisplaySelection;
}

export const initialState: SearchState = {
  status: SearchStatus.isSearching,
  totalCount: 0,
  searchTerm: '',
  selectedContentTypeFilterValue: ContentTypeFilterAllOption,
  mixedContentType: {},
};
